// extracted by mini-css-extract-plugin
module.exports =  {"colorList":"rB82IH"};